import { useContext, useEffect, useState } from "react";
import { fetchData, GET_ALL_BLOG } from "../../components/Service";
import moment from "moment";
import {
  Link,
  useLocation,
} from "../../../node_modules/react-router-dom/dist/index";
import { scrollTop } from "../../components/Helper";
import { Context } from "../../components/Context";

const Blog = () => {
  const location = useLocation();
  const [list, setList] = useState([]);
  const [pageUrl, setPageUrl] = useState();
  const [notFound, setNotFound] = useState(false);
 const [context,setContext] = useContext(Context);
  const setListView = (value) => {
    setContext((prev) => ({...prev,listView:value  }))
  }

  const getList = () => {
    fetchData(
      pageUrl ? pageUrl : GET_ALL_BLOG,
      "GET",
      "",
      false,
      false,
      (res) => {
        if (res.status) {
          setNotFound(false);
          setList(res?.data);
        } else {
          setNotFound(true);
          setList([]);
        }
      }
    );
  };

  useEffect(() => {
    scrollTop();
    getList();
  }, [pageUrl]);

  return (
    <div className="col-lg-12">
      <div className="card card-forum">
        <div className="card-header usa-bg">
          <div className="national-bg">
            <div className="row d-flex align-items-center ind1">
              <div className="col-lg-3">
                <h4 class="text-white d-flex mb-0 py-2">
                  {location?.state?.pageTitle ?? "Blogs"}
                </h4>
              </div>
              <div className="col-lg-9 ms-auto text-start text-lg-end ">
                {context.listView ? (
                  <>
                    <div class="list-frid-view cursor-pointer  ms-lg-1">
                      <img
                        src="/assets/images/list-active.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                    <div
                      class="list-frid-view cursor-pointer "
                      onClick={() => setListView(false)}
                    >
                      <img
                        src="/assets/images/grid-inactive.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      class="list-frid-view cursor-pointer  ms-lg-1 "
                      onClick={() => setListView(true)}
                    >
                      <img
                        src="/assets/images/list-inactive.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                    <div class="list-frid-view cursor-pointer ">
                      <img
                        src="/assets/images/grid-active.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
		{context.listView ? (
				  <div className="card-body bg-white p-1 body-minh">
					<div className="table-responsive">
					  <table className="table table-striped">
						<thead>
						  <tr className="table-active">
							<th scope="col">Title</th>
							<th scope="col"></th>
		
							<th scope="col">Category</th>
							<th scope="col">Date</th>
						  </tr>
						</thead>
						<tbody>
						  {list?.data &&
							list?.data?.length > 0 &&
							list?.data?.map((item) => (
							  <tr key={item.id}>
								<td>
								  <Link to={`/blogs/${item.id}`}>
									{item?.title ?? "N/A"}
								  </Link>
								</td>
								<td>
								  <span className="">
									{item?.image ? (
                    <Link to={`/blogs/${item.id}`}>
									  <img
										className="mx-2 cursor-pointer mx-2"
										src="/assets/images/icons/photo-img.png"
										alt="photo"										
									  />
                    </Link>
									) : (
									  <span className="mx-2 empty-icon-margin" ></span>
									)}
								 
									{item?.use_address_map === 1 ? (
									  <img
										className="cursor-pointer mx-2"
										onClick={() => {
										  console.log("first");
										 
										}}
										src="/assets/images/icons/map-pin.png"
										alt="map"
									  />
									) : (
									  <span className="mx-2 empty-icon-margin" ></span>
		
									)}
								  </span>
								</td>
		
								<td>
									{item?.category?.name ?? "N/A"}
								</td>
								<td>
								  {item.created_at
									? moment(item.created_at).format("DD-MMM-YYYY")
									: ""}
								</td>
							  </tr>
							))}
		
						  {notFound && (
							<tr>
							  <td
								className="text-center h6 text-danger py-3"
								colSpan={4}
							  >
								No Records Found!
							  </td>
							</tr>
						  )}
						</tbody>
					  </table>
					</div>
					{list?.data && (
					  <nav className="pt-3">
						<ul className="pagination justify-content-end">
						  <li
							className={`page-item ${
							  list.prev_page_url ? "" : "disabled"
							}`}
						  >
							<button
							  type="button"
							  className="page-link"
							  onClick={() => setPageUrl(list.prev_page_url)}
							>
							  <span aria-hidden="true">&laquo;</span> Previous
							</button>
						  </li>
						  <li
							className={`page-item ${
							  list.next_page_url ? "" : "disabled"
							}`}
						  >
							<button
							  type="button"
							  className="page-link"
							  onClick={() => setPageUrl(list.next_page_url)}
							>
							  Next <span aria-hidden="true">&raquo;</span>
							</button>
						  </li>
						</ul>
					  </nav>
					)}
				  </div>
				) : (
        <div className="card-body bg-white p-1 body-minh">
          <div className="row">
            {list?.data &&
              list?.data?.length > 0 &&
              list?.data?.map((item) => (
                <div
                  key={item.id}
                  className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 event_n mb-1"
                >
                  <div className="card-grid-2 hover-up h-100 mb-0">
                    <Link to={`/blogs/${item.id}`}>
                      <div className="ne-img-175">
                        <img
                          src={item.image ?? "/assets/images/no-image.jpg"}
                          alt="..."
                        />
                      </div>
                    </Link>
                    <span className="stick">{item?.category?.name}</span>
                    <div className="card-block-info position-relative">
                      <h6>
                        <Link to={`/blogs/${item.id}`}>{item.title}</Link>
                      </h6>
                      <div className="card-2-bottom mt-30">
                        <div className="row d-flex align-items-center">
                          <div className="col-7 d-flex align-items-center ">
                            <img
                              src="/assets/images/icons/cal.png"
                              className="me-2"
                            />
                            <span className="text-muted">
                              {item.created_at
                                ? moment(item.created_at).format("DD-MMM-YYYY")
                                : ""}
                            </span>
                          </div>
                          <div className="col-5 ps-0 text-end">
                            <Link
                              to={`/blogs/${item.id}`}
                              className="btn btn-apply-now font11"
                            >
                              View More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            {notFound && (
              <div className="text-center h6 text-danger py-3">
                No Records Found!
              </div>
            )}
          </div>
          {list?.data && (
            <nav className="pt-3">
              <ul className="pagination justify-content-end">
                <li
                  className={`page-item ${
                    list.prev_page_url ? "" : "disabled"
                  }`}
                >
                  <button
                    type="button"
                    className="page-link"
                    onClick={() => setPageUrl(list.prev_page_url)}
                  >
                    <span aria-hidden="true">&laquo;</span> Previous
                  </button>
                </li>
                <li
                  className={`page-item ${
                    list.next_page_url ? "" : "disabled"
                  }`}
                >
                  <button
                    type="button"
                    className="page-link"
                    onClick={() => setPageUrl(list.next_page_url)}
                  >
                    Next <span aria-hidden="true">&raquo;</span>
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
		  )}
      </div>
    </div>
  );
};

export default Blog;
